var map = {
	"./ar.json": 82045,
	"./ch.json": 99645,
	"./en.json": 13341,
	"./fr.json": 49998,
	"./gr.json": 27359,
	"./it.json": 55831,
	"./ru.json": 23991,
	"./sp.json": 86965,
	"./sw.json": 5140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49850;